<template>
  <div class="WorkorderHistory" ref="WorkorderHistory">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <div
          :class="{ 'col-12': workorderHistory_row_click }"
          style="width:100vw"
        >
          <b-row class="mx-0 mb-3">
            <b-col cols="1"> </b-col>

            <b-col cols="10">
              <b-col
                cols="12"
                class="p-0 m-0 mt-4"
                style="font-size: 1.75rem; color: #000000"
              >
                <span class="m-auto">工單履歷</span>
              </b-col>

              <template v-if="!workorderHistory_row_click">
                <b-col cols="12" class="mx-0" style="margin-top: 2rem">
                  <b-row>
                    <commonQueryIoT />
                  </b-row>
                </b-col>

                <b-col cols="12" class="text-right" style="margin-top: 2rem">
                  <exportCsv />
                </b-col>

                <b-col
                  cols="12"
                  class="text-right mx-0 px-0"
                  style="margin-top: 0.6rem"
                >
                  <template v-if="queryProcess == 'package'">
                    <workorderHistoryPackageData class="text-left" />
                  </template>
                  <template v-else-if="queryProcess == 'container'">
                    <workorderHistoryContainerData class="text-left" />
                  </template>
                  <template v-else>
                    <workorderHistoryData class="text-left" />
                  </template>
                </b-col>
              </template>
              <template v-else>
                <b-row class="mx-0">
                  <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="px-0">
                    <div class="WorkorderHistory-back-button">
                      <p
                        @click="
                          queryProcess == 'container' && containerWorkCode
                            ? (containerWorkCode = false)
                            : clear_rowClickData()
                        "
                      >
                        返回
                      </p>
                    </div>
                  </b-col>
                  <b-col
                    v-if="queryProcess == 'package'"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                    xl="12"
                    class="px-0"
                    style="background-color: #f2f2f2"
                  >
                    <workCodeInformationPackage
                      class="text-left"
                      style="margin-top: 1.875rem"
                    />
                    <produceInformationPackage
                      class="text-left"
                      style="margin-top: 1.875rem; min-height: 80px"
                    />
                    <shipmentInformation
                      class="text-left"
                      style="margin-top: 1.875rem"
                    />
                    <packageInformation
                      class="text-left"
                      style="margin-top: 1.875rem"
                    />
                    <palletInformation
                      class="text-left"
                      style="margin-top: 1.875rem"
                    />
                  </b-col>
                  <b-col
                    v-else-if="
                      queryProcess == 'container' && !containerWorkCode
                    "
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                    xl="12"
                    class="px-0"
                    style="background-color: #f2f2f2"
                  >
                    <containerInformation
                      class="text-left"
                      style="margin-top: 1.875rem; min-height: 80px"
                    />
                    <containerTime
                      class="text-left"
                      style="margin-top: 1.875rem; min-height: 80px"
                    />
                    <containerDetail
                      class="text-left"
                      style="margin-top: 1.875rem; min-height: 80px"
                    />
                  </b-col>
                  <b-col
                    v-else
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                    xl="12"
                    class="px-0"
                    style="background-color: #f2f2f2"
                  >
                    <workorderHistoryCodeInformation class="text-left mt-2" />
                    <headingProduceInformation class="text-left" />

                    <produceInformation class="text-left" />

                    <workorderHistoryWireUseInformation class="text-left" />

                    <moldUseInformation class="text-left" />

                    <threadUseInformation class="text-left" />

                    <totalProduceTime class="text-left" />

                    <b-row class="mx-0" style="">
                      <!-- <b-col cols="12" class="" style="">
                        <b-row class="mx-0">
                          <div
                            style="
                              width: 140px;
                              margin-right: 0.5rem;
                              border-bottom: 0.6rem #427ace solid;
                              padding: 0.5rem 1rem 0 1rem;
                              background-color: transparent;
                              color: #427ace;
                              font-size: 1rem;
                              font-family: dfyuanstd-w5, dfyuanstd-w3;
                              cursor: pointer;
                            "
                            @click="process_insp_select = 5"
                          >
                            打頭
                          </div>
                          <div
                            style="
                              width: 140px;
                              margin-right: 0.5rem;
                              border-bottom: 0.6rem #009245 solid;
                              padding: 0.5rem 1rem 0 1rem;
                              background-color: transparent;
                              color: #009245;
                              font-size: 1rem;
                              font-family: dfyuanstd-w5, dfyuanstd-w3;
                              cursor: pointer;
                            "
                            @click="process_insp_select = 6"
                          >
                            輾牙
                          </div>
                          <div
                            style="
                              width: 140px;
                              margin-right: 0.5rem;
                              border-bottom: 0.6rem #ff6b00 solid;
                              padding: 0.5rem 1rem 0 1rem;
                              background-color: transparent;
                              color: #ff6b00;
                              font-size: 1rem;
                              font-family: dfyuanstd-w5, dfyuanstd-w3;
                              cursor: pointer;
                            "
                            @click="process_insp_select = 7"
                          >
                            熱處理
                          </div>
                        </b-row>
                      </b-col> -->
                      <b-col cols="12" class="" style="margin-top: 1.5rem">
                        <inspectionUseInformation class="text-left px-0" />
                      </b-col>
                      <heatTreatmentWorkData />
                    </b-row>
                  </b-col>
                </b-row>
              </template>
            </b-col>

            <b-col cols="1"> </b-col>
          </b-row>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import workorderHistoryData from "@/components/workorderHistoryData.vue";
import workorderHistoryCodeInformation from "@/components/workorderHistoryCodeInformation.vue";
import workorderHistoryWireUseInformation from "@/components/workorderHistoryWireUseInformation.vue";
import headingProduceInformation from "@/components/headingProduceInformation.vue";
import produceInformation from "@/components/produceInformation.vue";
import moldUseInformation from "@/components/moldUseInformation.vue";
import threadUseInformation from "@/components/threadUseInformation.vue";
import inspectionUseInformation from "@/components/inspectionUseInformation.vue";
import heatTreatmentWorkData from "@/components/heatTreatmentWorkData.vue";
import totalProduceTime from "@/components/totalProduceTime.vue";

import workorderHistoryPackageData from "@/components/workorderHistoryPackageData.vue";
import workCodeInformationPackage from "@/components/workCodeInformationPackage.vue";
import shipmentInformation from "@/components/shipmentInformation.vue";
import produceInformationPackage from "@/components/produceInformationPackage.vue";
import packageInformation from "@/components/packageInformation.vue";
import palletInformation from "@/components/palletInformation.vue";

import workorderHistoryContainerData from "@/components/workorderHistoryContainerData.vue";
import containerInformation from "@/components/containerInformation.vue";
import containerDetail from "@/components/containerDetail.vue";
import containerTime from "@/components/containerTime.vue";

import commonQueryIoT from "@/components/commonQueryIoT.vue";
import exportCsv from "@/components/exportCsv.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "WorkorderHistory",
  data() {
    return {
      workorderHistory_row_click: false,
      containerWorkCode: false,
      // process_insp_select: 0,
      workorder_detail: {
        // device_name: "--",
        workCode: "--",
        workOrgCode: "--",
        work_qty: "--",
        commodity_code: "--",
        unit_weight: "--",
        standard_weight: "--",
        product_name: "--",
        wire_commodity_code: "--",
        wire_product_name: "--",
        material_weight: "--",
        wire_need_weight: "--",
        mould_code: "--",
        control_card: "--",
        actual_weight: "--"
      },
      total_inspection_data: {},
      workorderHistoryDataFields: [
        {
          key: "work_org_code",
          label: "工單",
          sortable: true
        },
        {
          key: "processSchedule",
          label: "製程進度",
          sortable: true
        },
        {
          key: "itemName",
          label: "料名",
          sortable: true
        },
        {
          key: "qty",
          label: "派工數量",
          sortable: true
        },
        {
          key: "time",
          label: "完工日期",
          sortable: true
        }
      ]
    };
  },
  created: function() {
    this.change_selectPage("workorderhistory");
    this.change_selectPageName(this.pageName.workorderhistory);
    this.setCommonQueryData();
    this.setQueryInput();
    this.set_workorderHistoryDataFields(this.workorderHistoryDataFields);
    this.set_workorderHistoryTableStyle();

    //即時看板裝櫃 出貨明細點入
    let vm = this;
    if (vm.containerDetailQuery.active) {
      vm.workorderHistory_row_click = true;
      vm.set_inspectionUseSingleProcess(false);
      vm.trigger_loadScreenModal();
      vm.queryWorkIdFunction(vm.containerDetailQuery.pkg_wko_code);
    }
  },
  mounted: function() {
    let vm = this;
    vm.resetExportCsv();
    vm.setExportDataTitle();
  },
  components: {
    workorderHistoryData,
    workorderHistoryCodeInformation,
    workorderHistoryWireUseInformation,
    headingProduceInformation,
    produceInformation,
    moldUseInformation,
    threadUseInformation,
    inspectionUseInformation,
    totalProduceTime,
    commonQueryIoT,
    exportCsv,
    heatTreatmentWorkData,
    workCodeInformationPackage,
    shipmentInformation,
    produceInformationPackage,
    packageInformation,
    palletInformation,
    workorderHistoryPackageData,
    workorderHistoryContainerData,
    containerInformation,
    containerDetail,
    containerTime
  },
  watch: {
    mainQueryResponse: {
      handler() {
        let vm = this;
        let queryProcess = vm.queryProcess;
        let workorderArray = [];
        let exportData = [];
        if (
          vm.mainQueryResponse == "查無資料" ||
          vm.mainQueryResponse == "時間尚未選擇"
        ) {
          if (queryProcess == "package") {
            vm.set_workorderHistoryPackageDataItem(workorderArray);
          } else if (queryProcess == "container") {
            vm.set_workorderHistoryContainerDataItem(workorderArray);
          } else {
            vm.set_workorderHistoryDataItem(workorderArray);
          }
          vm.set_exportData(exportData);
          vm.set_alertMsg(vm.mainQueryResponse);
          vm.settimeout_alertModal();
          return;
        }

        let queryData = vm.mainQueryResponse;

        if (queryProcess == "package") {
          workorderArray = queryData;
          vm.setExportDataTitle();
          for (var i = 0; i < queryData.length; i++) {
            exportData.push({
              work_code: queryData[i]["work_code"],
              product_code: queryData[i]["product_code"],
              product_name: '"' + queryData[i]["product_name"] + '"',
              runcard_code: queryData[i]["runcard_code"],
              box_qty: queryData[i]["box_qty"],
              start_time: queryData[i]["start_time"],
              end_time: queryData[i]["end_time"]
            });
          }
        } else if (queryProcess == "container") {
          workorderArray = queryData;
          vm.setExportDataTitle();
          for (var i = 0; i < queryData.length; i++) {
            exportData.push({
              pkg_wko_code: queryData[i]["pkg_wko_code"],
              container_no: queryData[i]["container_no"],
              license_plate: queryData[i]["license_plate"],
              total_weight: queryData[i]["total_weight"],
              total_plno: queryData[i]["total_plno"],
              start_time: queryData[i]["start_time"],
              end_time: queryData[i]["end_time"]
            });
          }
        } else {
          vm.setExportDataTitle();
          for (var i = 0; i < queryData.length; i++) {
            var workorderObj = {};
            workorderObj["workID"] = queryData[i]["workID"];
            workorderObj["work_org_code"] = queryData[i]["work_org_code"];
            // workorderObj["placeItem"] = queryData[i]["factory_name"];
            // workorderObj["groupItem"] = queryData[i]["group_name"];
            // workorderObj["device"] = queryData[i]["device_name"];
            workorderObj["processSchedule"] = queryData[i]["processSchedule"];
            workorderObj["itemName"] = queryData[i]["product_name_chinese"];
            workorderObj["qty"] = queryData[i]["work_qty"];
            workorderObj["time"] = queryData[i]["completion_date"];
            workorderArray.push(workorderObj);
            exportData.push({
              work_org_code: queryData[i]["work_org_code"],
              processSchedule: queryData[i]["processSchedule"],
              itemName: queryData[i]["product_name_chinese"],
              qty: queryData[i]["work_qty"],
              time: queryData[i]["completion_date"]
            });
          }
        }

        if (workorderArray.length != 0) {
          vm.workorderItems = workorderArray;
          if (queryProcess == "package") {
            vm.set_workorderHistoryPackageDataItem(workorderArray);
          } else if (queryProcess == "container") {
            vm.set_workorderHistoryContainerDataItem(workorderArray);
          } else {
            vm.set_workorderHistoryDataItem(workorderArray);
          }
          vm.set_exportData(exportData);
        }
      }
    },
    rowClickData: {
      handler() {
        let vm = this;
        let row_data_array = Object.keys(vm.rowClickData);

        if (row_data_array.length == 0) {
          vm.reset([]);
          vm.set_workorderHistoryCodeInformationItem([]);
          vm.set_workorderHistoryWireUseInformationItem([]);
          vm.set_headingProduceInformationItem([]);
          vm.set_produceInformationItem([]);
          vm.set_moldUseInformationItem([]);
          vm.set_inspectionUseSingleProcess(true);
          vm.set_inspectionUseInformationData({});
          vm.set_totalProduceTimeItem([]);
          vm.set_totalProduceTiming([]);
          vm.set_htWorkDataItem([]);
          vm.clear_produceInformationPackageItem();
          vm.clear_workCodeInformationPackageItem();
          vm.clear_shipmentInformationItem();
          vm.clear_packageInformationItem();
          vm.clear_palletInformationItem();
          vm.clear_containerDetailItem();
          vm.clear_containerInformationItem();
          vm.clear_containerTimeItem();
        } else {
          console.log(vm.rowClickData);
          vm.workorderHistory_row_click = true;
          vm.trigger_loadScreenModal();
          vm.set_inspectionUseSingleProcess(false);
          if (vm.queryProcess == "package") {
            vm.queryWorkIdPackage(vm.rowClickData.items.work_code);
          } else if (vm.queryProcess == "container") {
            vm.queryWorkIdContainer(vm.rowClickData.items.pkg_wko_code);
          } else {
            vm.queryWorkIdFunction(
              vm.rowClickData.items.workID,
              vm.rowClickData.items.processSchedule
            );
          }
        }
      }
    },
    containerDetailQuery: {
      handler() {
        let vm = this;
        if (vm.containerDetailQuery.active) {
          vm.workorderHistory_row_click = true;
          vm.set_inspectionUseSingleProcess(false);
          vm.containerWorkCode = true;
          vm.trigger_loadScreenModal();
          vm.queryWorkIdFunction(vm.containerDetailQuery.pkg_wko_code);
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      pageName: "getlogin/get_pageName",
      mainQueryResponse: "commonqueryiot/get_queryResponse",
      queryProcess: "commonqueryiot/get_queryProcess",
      rowClickData: "workorderHistoryData/get_rowClickData",
      workorderHistoryDataFields:
        "workorderHistoryData/get_workorderHistoryDataFields",
      workorderHistoryPackageDataFields:
        "workorderHistoryPackageData/get_workorderHistoryPackageDataFields",
      workorderHistoryContainerDataFields:
        "workorderHistoryContainerData/get_workorderHistoryContainerDataFields",
      containerDetailQuery: "containerDetail/get_containerDetailQuery"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal",
      set_phpfunction: "commonqueryiot/set_phpfunction",
      set_selectTag: "commonqueryiot/set_selectTag",
      set_selectTagCheck: "commonqueryiot/set_selectTagCheck",
      set_processOption: "commonqueryiot/set_processOption",
      set_deviceOption: "commonqueryiot/set_deviceOption",
      set_groupOption: "commonqueryiot/set_groupOption",
      set_queryResponse: "commonqueryiot/set_queryResponse",
      set_queryProcess: "commonqueryiot/set_queryProcess",
      trigger_loadScreenModal: "loadscreenmodal/trigger_loadScreenModal",
      hide_loadScreenModal: "loadscreenmodal/hide_loadScreenModal",
      set_exportData: "exportcsv/set_exportData",
      set_exportDataTitle: "exportcsv/set_exportDataTitle",
      set_exportFileName: "exportcsv/set_exportFileName",
      set_workorderHistoryDataFields:
        "workorderHistoryData/set_workorderHistoryDataFields",
      set_workorderHistoryTableStyle:
        "workorderHistoryData/set_workorderHistoryTableStyle",
      set_workorderHistoryDataItem:
        "workorderHistoryData/set_workorderHistoryDataItem",
      clear_workorderHistoryDataItem:
        "workorderHistoryData/clear_workorderHistoryDataItem",
      clear_rowClickData: "workorderHistoryData/clear_rowClickData",
      set_workorderHistoryCodeInformationItem:
        "workorderHistoryCodeInformation/set_workorderHistoryCodeInformationItem",
      set_workorderHistoryWireUseInformationItem:
        "workorderHistoryWireUseInformation/set_workorderHistoryWireUseInformationItem",
      set_headingProduceInformationItem:
        "headingProduceInformation/set_headingProduceInformationItem",
      set_produceInformationItem:
        "produceInformation/set_produceInformationItem",
      set_moldUseInformationItem:
        "moldUseInformation/set_moldUseInformationItem",
      set_threadUseInformationItem:
        "threadUseInformation/set_threadUseInformationItem",
      set_inspectionUseInformationData:
        "inspectionUseInformation/set_inspectionUseInformationData",
      set_inspectionUseSingleProcess:
        "inspectionUseInformation/set_inspectionUseSingleProcess",
      set_totalProduceTimeItem: "totalProduceTime/set_totalProduceTimeItem",
      set_totalProduceTiming: "totalProduceTime/set_totalProduceTiming",
      set_htWorkDataItem: "htWorkData/set_htWorkDataItem",
      set_workorderHistoryPackageDataItem:
        "workorderHistoryPackageData/set_workorderHistoryPackageDataItem",
      clear_workorderHistoryPackageDataItem:
        "workorderHistoryPackageData/clear_workorderHistoryPackageDataItem",
      set_workorderHistoryContainerDataItem:
        "workorderHistoryContainerData/set_workorderHistoryContainerDataItem",
      clear_workorderHistoryContainerDataItem:
        "workorderHistoryContainerData/clear_workorderHistoryContainerDataItem",
      set_containerDetailItem: "containerDetail/set_containerDetailItem",
      clear_containerDetailItem: "containerDetail/clear_containerDetailItem",
      clear_containerDetailQuery: "containerDetail/clear_containerDetailQuery",
      set_containerInformationItem:
        "containerInformation/set_containerInformationItem",
      clear_containerInformationItem:
        "containerInformation/clear_containerInformationItem",
      set_containerTimeItem: "containerTime/set_containerTimeItem",
      clear_containerTimeItem: "containerTime/clear_containerTimeItem",
      set_produceInformationPackageItem:
        "produceInformationPackage/set_produceInformationPackageItem",
      clear_produceInformationPackageItem:
        "produceInformationPackage/clear_produceInformationPackageItem",
      set_workCodeInformationPackageItem:
        "workCodeInformationPackage/set_workCodeInformationPackageItem",
      clear_workCodeInformationPackageItem:
        "workCodeInformationPackage/clear_workCodeInformationPackageItem",
      set_shipmentInformationItem:
        "shipmentInformation/set_shipmentInformationItem",
      clear_shipmentInformationItem:
        "shipmentInformation/clear_shipmentInformationItem",
      set_packageInformationItem:
        "packageInformation/set_packageInformationItem",
      clear_packageInformationItem:
        "packageInformation/clear_packageInformationItem",
      set_palletInformationItem: "palletInformation/set_palletInformationItem",
      clear_palletInformationItem:
        "palletInformation/clear_palletInformationItem"
    }),
    setCommonQueryData() {
      let vm = this;
      vm.set_phpfunction("MainQuery");
    },
    setQueryInput() {
      let vm = this;
      vm.set_selectTag({
        process: true,
        deviceCode: true,
        productCode: true,
        workCode: false
      });
      vm.set_selectTagCheck({
        startTime: true,
        endTime: true,
        process: true,
        deviceCode: true,
        productCode: false,
        workCode: false
      });
    },
    getSelectOption() {
      let vm = this;
      var params = {};
      params["vuePage"] = "selectoption";
      params["methods"] = "GET";
      params["whichFunction"] = "SelectOption";
      console.log(params);
      vm.axiosAction(params).then(() => {
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          vm.set_processOption(result.QueryTableData.process);
          vm.set_groupOption(result.QueryTableData.group);
          vm.set_deviceOption(result.QueryTableData.device);
        }
      });
    },
    resetExportCsv() {
      let vm = this;
      vm.set_exportData([]);
      vm.set_exportDataTitle([]);
      vm.set_exportFileName("");
    },
    setExportDataTitle() {
      let vm = this;
      let exportDataTitle = [];
      if (vm.queryProcess == "package") {
        vm.workorderHistoryPackageDataFields.forEach(data => {
          exportDataTitle.push(data.label);
        });
      } else if (vm.queryProcess == "container") {
        vm.workorderHistoryContainerDataFields.forEach(data => {
          exportDataTitle.push(data.label);
        });
      } else {
        vm.workorderHistoryDataFields.forEach(data => {
          exportDataTitle.push(data.label);
        });
      }

      vm.set_exportDataTitle(exportDataTitle);
    },
    queryWorkIdFunction(workID, schedule = null) {
      let vm = this;
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["whichFunction"] = "QueryWorkId";
      params["workID"] = workID;
      params["schedule"] = schedule;
      console.log(params);
      vm.axiosAction(params).then(() => {
        vm.hide_loadScreenModal();
        var result = vm.axiosResult;
        console.log(result);
        // vm.change_tableBusy();
        if (result["Response"] == "ok") {
          let result_Data = result["QueryTableData"][0];

          let work_code_information_response =
            result_Data["work_code_information"];
          let work_code_information_item = [];
          if (work_code_information_response.length > 0) {
            work_code_information_response.forEach(data => {
              let work_code_information_obj = {};
              // work_code_information_obj["code"] = {
              //   code: data["code"],
              //   org_code: data["org_code"],
              // };
              work_code_information_obj["work_org_code"] =
                data["work_org_code"];
              work_code_information_obj["productCode"] = data["productCode"];
              work_code_information_obj["control_card"] = data["control_card"];
              work_code_information_obj["product_chinese_name"] =
                data["product_chinese_name"];
              work_code_information_obj["mould_code"] = data["mould_code"];
              work_code_information_obj["work_qty"] = data["work_qty"];
              work_code_information_obj["standard_total_weight"] =
                data["standard_total_weight"];
              work_code_information_item.push(work_code_information_obj);
            });
          }
          vm.set_workorderHistoryCodeInformationItem(
            work_code_information_item
          );

          let wire_information_response = result_Data["wire_information"];
          let wire_information_item = [];
          if (wire_information_response.length > 0) {
            wire_information_response.forEach(data => {
              let wire_information_obj = {};
              wire_information_obj["code"] = data["code"];
              wire_information_obj["chinese_name"] = data["chinese_name"];
              wire_information_obj["scroll_no"] = data["scroll_no"];
              wire_information_obj["furnaceCode"] = data["furnaceCode"];
              wire_information_obj["consumption"] = data["consumption"];
              // wire_information_obj["attrition"] = data["attrition"];
              wire_information_item.push(wire_information_obj);
            });
          }
          vm.set_workorderHistoryWireUseInformationItem(wire_information_item);

          let heading_produce_information_response =
            result_Data["heading_produce_information"];
          let heading_produce_information_item = [];
          if (heading_produce_information_response.length > 0) {
            heading_produce_information_response.forEach(data => {
              let heading_produce_information_obj = {};
              heading_produce_information_obj["item_title"] =
                data["item_title"];
              heading_produce_information_obj["unit_weight"] =
                data["unit_weight"];
              heading_produce_information_obj["standard_total_weight"] =
                data["standard_total_weight"];
              heading_produce_information_obj["material_total_weight"] =
                data["material_total_weight"];
              heading_produce_information_item.push(
                heading_produce_information_obj
              );
            });
          }
          vm.set_headingProduceInformationItem(
            heading_produce_information_item
          );

          let produce_information_response = result_Data["produce_information"];
          let produce_information_item = [];
          if (produce_information_response.length > 0) {
            produce_information_response.forEach(data => {
              let produce_information_obj = {};
              produce_information_obj["process"] = data["process"];
              produce_information_obj["pre_total_weight"] =
                data["pre_total_weight"];
              produce_information_obj["total_weight"] = data["total_weight"];
              produce_information_obj["attrition_rate_act"] =
                data["attrition_rate_act"];
              produce_information_obj["attrition_rate_standard"] =
                data["attrition_rate_standard"];
              produce_information_obj["rework"] = data["rework"];
              if (data.hasOwnProperty("ht_in_process")) {
                produce_information_obj["ht_in_process"] =
                  data["ht_in_process"];
              } else {
                produce_information_obj["ht_in_process"] = "-";
              }

              produce_information_item.push(produce_information_obj);
            });
          }
          vm.set_produceInformationItem(produce_information_item);

          let use_mould_response = result_Data["use_mould"];
          let use_mould_item = [];
          if (use_mould_response.length > 0) {
            use_mould_response.forEach(data => {
              let use_mould_obj = {};
              use_mould_obj["code"] = data["code"];
              use_mould_obj["seriesNo"] = data["seriesNo"];
              use_mould_obj["name"] = data["name"];
              use_mould_obj["used_life"] = data["used_life"];
              use_mould_obj["standard_life"] = data["standard_life"];
              use_mould_item.push(use_mould_obj);
            });
          }
          vm.set_moldUseInformationItem(use_mould_item);

          let use_thread_response = result_Data["use_thread"];
          let use_thread_item = [];
          if (use_thread_response.length > 0) {
            use_thread_response.forEach(data => {
              let use_thread_obj = {};
              use_thread_obj["code"] = data["code"];
              use_thread_obj["seriesNo"] = data["seriesNo"];
              use_thread_obj["name"] = data["name"];
              use_thread_obj["used_life"] = data["used_life"];
              use_thread_obj["standard_life"] = data["standard_life"];
              use_thread_item.push(use_thread_obj);
            });
          }
          vm.set_threadUseInformationItem(use_thread_item);

          let total_work_time_response = result_Data["total_work_time"];
          let total_work_time_item = [];
          if (total_work_time_response.length > 0) {
            total_work_time_response.forEach(data => {
              let total_work_time_obj = {};
              total_work_time_obj["code"] = data["code"];
              total_work_time_obj["device_name"] = data["device_name"];
              total_work_time_obj["startTime"] = data["startTime"];
              total_work_time_obj["endTime"] = data["endTime"];
              total_work_time_obj["totalTime"] = data["total_time"];
              if (data.hasOwnProperty("rework")) {
                total_work_time_obj["rework"] = data["rework"];
              } else {
                total_work_time_obj["rework"] = false;
              }
              if (data.hasOwnProperty("ht_in_process")) {
                total_work_time_obj["ht_in_process"] = data["ht_in_process"];
              } else {
                total_work_time_obj["ht_in_process"] = false;
              }
              total_work_time_item.push(total_work_time_obj);
            });
          }
          vm.set_totalProduceTimeItem(total_work_time_item);

          let total_inspection_data_response =
            result_Data["total_inspection_data"];
          vm.set_inspectionUseInformationData(total_inspection_data_response);
          let ht_work_data = result_Data["ht_work_data"];
          vm.set_htWorkDataItem(ht_work_data);
        } else if (result["Response"] == "no data") {
          vm.set_alertMsg("查無資料");
          vm.settimeout_alertModal();
        } else {
          vm.set_alertMsg(result["Response"]);
          vm.settimeout_alertModal();
        }
      });
    },
    queryWorkIdPackage(workID) {
      let vm = this;
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["whichFunction"] = "QueryWorkIdPackage";
      params["work_code"] = workID;
      vm.axiosAction(params).then(() => {
        vm.hide_loadScreenModal();
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          var result_Data = result["QueryTableData"];
          vm.set_produceInformationPackageItem(result_Data["product_info"]);
          vm.set_workCodeInformationPackageItem(result_Data["work_code_info"]);
          vm.set_shipmentInformationItem(result_Data["shipment_info"]);
          vm.set_packageInformationItem(result_Data["package_info"]);
          vm.set_palletInformationItem(result_Data["pallet_info"]);
        } else if (result["Response"] == "no data") {
          vm.set_alertMsg("查無資料");
          vm.settimeout_alertModal();
        } else {
          vm.set_alertMsg(result["Response"]);
          vm.settimeout_alertModal();
        }
      });
    },
    queryWorkIdContainer(workID) {
      let vm = this;
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["whichFunction"] = "QueryWorkIdContainer";
      params["work_code"] = workID;
      vm.axiosAction(params).then(() => {
        vm.hide_loadScreenModal();
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          var result_Data = result["QueryTableData"];
          vm.set_containerDetailItem(result_Data["container_detail"]);
          vm.set_containerInformationItem(result_Data["container_information"]);
          vm.set_containerTimeItem(result_Data["container_time"]);
        } else if (result["Response"] == "no data") {
          vm.set_alertMsg("查無資料");
          vm.settimeout_alertModal();
        } else {
          vm.set_alertMsg(result["Response"]);
          vm.settimeout_alertModal();
        }
      });
    },
    resetField() {
      let vm = this;
      vm.reset([]);
      vm.set_workorderHistoryCodeInformationItem([]);
      vm.set_workorderHistoryWireUseInformationItem([]);
      vm.set_headingProduceInformationItem([]);
      vm.set_produceInformationItem([]);
      vm.set_moldUseInformationItem([]);
      vm.set_inspectionUseSingleProcess(true);
      vm.set_inspectionUseInformationData({});
      vm.set_totalProduceTimeItem([]);
      vm.set_totalProduceTiming([]);
      vm.set_htWorkDataItem([]);
      vm.clear_produceInformationPackageItem();
      vm.clear_workCodeInformationPackageItem();
      vm.clear_shipmentInformationItem();
      vm.clear_packageInformationItem();
      vm.clear_palletInformationItem();
      vm.clear_containerDetailItem();
      vm.clear_containerInformationItem();
      vm.clear_containerTimeItem();
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  },
  destroyed() {
    this.clear_workorderHistoryDataItem();
    this.clear_workorderHistoryPackageDataItem();
    this.clear_workorderHistoryContainerDataItem();
    this.set_queryProcess(null);
    this.clear_containerDetailQuery();
    this.clear_produceInformationPackageItem();
    this.clear_workCodeInformationPackageItem();
    this.clear_shipmentInformationItem();
    this.clear_packageInformationItem();
    this.clear_palletInformationItem();
    this.resetField();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss">
.WorkorderHistory-back-button p {
  border-radius: 5px;
  background-color: #4b8c80;
  color: #ffffff;
  padding: 0px 13px;
  width: 4.25rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  text-align: center;
  margin: 0px 0px 1.5rem;
  cursor: pointer;
}
</style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/WorkorderHistory.vue